import fetchUserState from "@api/operations/fetch-customer-state";
import getEnrollments from "@api/operations/fetch-enrollments";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { NextSeo } from "next-seo";
import React from "react";

import Center from "@components/Center";
import Container from "@components/Container";
import EnrolledCourses from "@components/EnrolledCourses";
import MainLayout from "@components/MainLayout";
import Spacer from "@components/Spacer";
import Title from "@components/Title";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;

  // token may not exist yet if you have just accessed the site supply a mock customer in this case
  if (!token) {
    return {
      props: {
        customer: { guest: true },
        enrollments: [],
      },
    };
  }

  const { customer } = await fetchUserState(token);
  const {
    enrollments: { list },
  } = await getEnrollments(token);

  return {
    props: {
      enrollments: list,
      customer,
    },
  };
};

type CoursePageProps = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function MyCoursesPage({ customer, enrollments }: CoursePageProps) {
  return (
    <Container>
      <NextSeo title="My Courses | Bobcat Online Training" />
      <Title>My Courses</Title>
      <Spacer size={"md"} />
      {customer.guest ? (
        <Center cy="login-required">Please log in before attempting to access your courses.</Center>
      ) : (
        <EnrolledCourses enrollments={enrollments} />
      )}
    </Container>
  );
}

MyCoursesPage.Layout = MainLayout;
